module.exports = __webpack_public_path__ + "static/media/Intellect.d4701861.svg";